import { SEARCH_PAGES } from 'modules/quickActionsMenu/constants';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { Fragment } from 'react';
import { KeyShift } from 'ui/icons/aurora/16px/cmdk';
import { colors } from 'ui/theme';
import { Count, FooterContainer, FooterShortcut } from './Footer.styled';

export const FOOTER_TEXT = {
  footerTestId: 'quick-actions-menu-footer',
  countTestId: 'quick-actions-menu-count',
};

export const Footer = ({ count }: { count: number }) => {
  const { pageState, debouncedSearchTerm } = useQuickActionsMenuContext();
  const { page } = pageState || {};

  const currentPage = Object.values(SEARCH_PAGES).find((searchPage) => searchPage.page === page);
  const { Icon = Fragment, key, term, type } = currentPage || {};

  /** Show count if there are results or if no results that have filtered to zero */
  const shouldShowCount = count > 0 || !!debouncedSearchTerm;
  const itemText = count === 1 && type ? type.slice(0, -1) : type || ''; // Ensure type is defined

  return (
    <>
      {!!currentPage && (
        <FooterContainer data-test={FOOTER_TEXT.footerTestId}>
          {shouldShowCount && (
            <Count
              data-test={FOOTER_TEXT.countTestId}
            >{`${count.toLocaleString()} ${itemText}`}</Count>
          )}
          <FooterShortcut>
            Hint: next time, press{' '}
            <KeyShift color={colors.iconSubtle} title="Shift key" titleId="shiftKeyId" /> +{' '}
            <Icon color={colors.iconSubtle} title={`${key} key`} titleId={`${key}KeyId`} /> to open{' '}
            {term}
          </FooterShortcut>
        </FooterContainer>
      )}
    </>
  );
};
